import { FC, ReactNode } from "react";
import { Box, BoxProps, TabsTrigger } from "shared/components/Spor";
import styled from "styled-components";

const _TabsStyled = styled(Box).withConfig({
  shouldForwardProp: (prop) => prop !== "pulsing",
})<{
  pulsing: boolean;
}>`
  height: 100%;
  width: 100%;
  > * {
    background-color: ${({ theme, pulsing }) =>
      pulsing ? theme.colorSuccessOutline : "transparent"};
    transition: opacity 200ms ease-in-out;
  }
`;

type TabWithPulseProps = {
  children: ReactNode;
  value: string;
  pulsing: boolean;
} & BoxProps;

const TabWithPulse: FC<TabWithPulseProps> = ({
  children,
  value,
  pulsing,
  ..._props
}) => <TabsTrigger value={value}>{children}</TabsTrigger>;

export default TabWithPulse;
